"use client";

import { useSyncExternalStore } from "react";

const subscribe = () => () => {};

// false on the server and while hydrating, true afterwards (and on any client
// render that isn't a hydration). Lets time-dependent output skip SSR without
// a state + effect re-render.
const useIsHydrated = () =>
  useSyncExternalStore(
    subscribe,
    () => true,
    () => false,
  );

export default useIsHydrated;
